import { useCallback } from 'react';

import { useI18n } from '@change-corgi/core/react/i18n';
import { useTracking } from '@change-corgi/core/react/tracking';
import { getWindowSafe } from '@change-corgi/core/window';

import { copyToClipboard } from 'src/app/shared/utils/clipboard';

import type { ActionsReturnType, GroupSharingHookProps } from './types';

export const PRIMARY_CTA_EVENT_NAME = 'primary_cta_facebook_group_post_sharing';
export const SECONDARY_CTA_EVENT_NAME = 'secondary_cta_facebook_group_post_sharing';

// TODO: This is not the final implementation. Adjust when flows are fully designed.
export function useFacebookGroupPostSharing(input: GroupSharingHookProps): ActionsReturnType {
	const i18n = useI18n();
	const { recommendedGroup } = input;
	const track = useTracking();
	const window = getWindowSafe();

	const primaryAction = useCallback(() => {
		void copyToClipboard(input.message, i18n);
		void track(PRIMARY_CTA_EVENT_NAME);

		if (window) {
			window.open(recommendedGroup?.url, '_blank', 'noopener,noreferrer');
		}
	}, [input.message, i18n, track, window, recommendedGroup?.url]);

	const secondaryAction = useCallback(() => {
		void track(SECONDARY_CTA_EVENT_NAME);

		if (window) {
			window.open(recommendedGroup?.url, '_blank', 'noopener,noreferrer');
		}
	}, [recommendedGroup, track, window]);

	return {
		primaryAction,
		secondaryAction,
	};
}
